import React from 'react';
import './style.scss';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../Shared/components/controls/Button';

const CardsListingCard = ({ data }) => {
  const { image, heading, text, content, hyperLink, primaryButton, secondaryButton } = data.fields;

  const shouldRenderImage = image?.value?.src;
  const shouldRenderPrimary = primaryButton?.value?.text;
  const shouldRenderSecondary = secondaryButton?.value?.text;
  const shouldRenderLink = hyperLink?.value?.text;

  const shouldRenderButtons = shouldRenderSecondary || shouldRenderPrimary || shouldRenderLink;

  return (
    <div className="cards-listing-card">
      {shouldRenderImage && (
        <div className="cl-card-image-wrapper">
          <Image field={image} className="cl-card-image" />
        </div>
      )}
      <div className="cl-card-content">
        <h3 className="cl-card-content-title">
          <Text field={heading} />
        </h3>
        <RichText className="cl-card-content-desc" field={text} />
        {content?.value && <RichText field={content} className="cl-card-content-content" />}
        {shouldRenderButtons && (
          <div className="cl-card-content-buttons">
            {shouldRenderPrimary && (
              <Button link={primaryButton} variant="contained" color="primary" />
            )}
            {shouldRenderSecondary && (
              <Button link={secondaryButton} variant="contained" color="primary" />
            )}
            {shouldRenderLink && (
              <Button link={hyperLink} variant="text" color="primary" arrow="left" />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CardsListingCard;
